'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

// Utils


// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _lodash = require('lodash');

var _authService = require('./authService');

var _navigationActions = require('../reducers/navigationActions');

var _currentUserSelector = require('../user/currentUserSelector');

var _PageLoader = require('../components/loaders/PageLoader');

var _PageLoader2 = _interopRequireDefault(_PageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var currentUserAvailableSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, function (currentUser) {
    return currentUser.get('authenticated') && currentUser.get('fetched');
});

var getLocation = function getLocation(state) {
    return state.get('routing') && state.get('routing').locationBeforeTransitions;
};

/**
 * Selector used to build up the user data for Intercom
 */

var authenticatedRouteSelector = (0, _reselect.createStructuredSelector)({
    isUserAvailable: currentUserAvailableSelector,
    location: getLocation
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        navigateToLogin: function navigateToLogin(_ref) {
            var from = _ref.from;
            return dispatch((0, _navigationActions.navigateToLogin)({ from: from }));
        }
    };
};

var AuthenticatedRoute = (_dec = (0, _reactRedux.connect)(authenticatedRouteSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(AuthenticatedRoute, _React$Component);

    function AuthenticatedRoute() {
        _classCallCheck(this, AuthenticatedRoute);

        return _possibleConstructorReturn(this, (AuthenticatedRoute.__proto__ || Object.getPrototypeOf(AuthenticatedRoute)).apply(this, arguments));
    }

    _createClass(AuthenticatedRoute, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                navigateToLogin = _props.navigateToLogin,
                location = _props.location;

            var pathname = (0, _lodash.get)(location, 'pathname');

            var authToken = (0, _authService.getCurrentUserToken)();
            if (!authToken) {
                console.warn('AuthenticatedContainer:' + ' Attempted to access an authenticated page without an authentication token');
                return navigateToLogin({ from: pathname });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isUserAvailable = this.props.isUserAvailable;


            if (!isUserAvailable) return _react2.default.createElement(_PageLoader2.default, null);

            return this.props.children;
        }
    }]);

    return AuthenticatedRoute;
}(_react2.default.Component)) || _class);
exports.default = AuthenticatedRoute;


AuthenticatedRoute.propTypes = {
    isUserAvailable: _propTypes2.default.bool,
    intercomUser: _propTypes2.default.object,
    analytics: _propTypes2.default.object,
    children: _propTypes2.default.object,
    location: _propTypes2.default.object,
    initialiseCurrentUser: _propTypes2.default.func,
    navigateToLogin: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/AuthenticatedContainer.js
// module id = 1670
// module chunks = 0